import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Ticket from "../CreateTicket";
import { getData } from "utils/queries";
import { formatDateTimeRange, getDateTimeFromDate } from "utils";
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

const EditTicket = () => {

  const [ticket, setTicket]= useState(null)

  const {ticket_id} = useParams()

  const userDetails = useAuthUser();

  console.log("userdetailsare", userDetails)

  const fetchTicketDetails = async (ticket_id) =>{
    try {

      const result = await getData(`ticket/tickets/${ticket_id}`);
      const Data = result?.data?.[0];
      console.log("result is", Data)
      
      if (Data) {
        // Fetch latest event details to get current booking_fee_percentage
        const eventResult = await getData(`event/events/${Data.event_id}`);
        const eventData = eventResult?.data?.data?.events;
        const percentage = eventData?.booking_fee_percentage ?? 10;
        
        const price = Number(Data.price) || 0;
        const calculatedFee = parseFloat((price * (percentage / 100)).toFixed(2));
        const customer_pays = parseFloat((price + calculatedFee).toFixed(2));

        const { date: startDate, hours: startHours, minutes: startMinutes } = 
          getDateTimeFromDate(Data.on_sale_from);
        const { date: endDate, hours: endHours, minutes: endMinutes } = 
          getDateTimeFromDate(Data.on_sale_to);

        const updatedDateAndTime = formatDateTimeRange(Data.on_sale_from, Data.on_sale_to);
        const variantKey = Data.variant_name || "undefined";

        const ticketsSold = Data.tickets_sold ?? Math.max(0, (Number(Data.quantity_available) || 0) - (Number(Data.current_quantity) || 0));

        setTicket({
          ticket_name: { label: Data.ticket_name, value: Data.ticket_name },
          event_name: { 
            label: Data.event_name, 
            value: Data.event_id,
            booking_fee_percentage: percentage,
            installment_plans: eventData?.installment_plans || []
          },
          ticket_type: { label: Data.ticket_type, value: Data.ticket_type },
          variant_name: { 
            label: Data.variant_name, 
            value: Data.variant_name 
          },
          image_url: Data.image_url,
          variant_type: Data.variant_type,
          parent_ticketID: Data.ticket_id,
          [variantKey]: {
            ...Data,
            booking_fee: calculatedFee,
            customer_pays: customer_pays,
            installment_min_amount: parseFloat(Data?.installment_min_amount ?? 0),
            installment_plans: (Data?.installment_plans || []).map(plan => 
              typeof plan === 'string' ? { label: plan.replace("installment_", "") + " Months", value: plan } : plan
            ),
            tickets_sold: ticketsSold,
            initial_tickets_sold: ticketsSold,
            initial_quantity_available: Data.quantity_available,
            initial_current_quantity: Data.current_quantity,
            variant_name: Data.variant_name,
            on_sale_from: startDate,
            startHours: { 
              label: updatedDateAndTime.startHours.label, 
              value: updatedDateAndTime.startHours.value 
            },
            startMinutes: { 
              label: updatedDateAndTime.startMinutes.label, 
              value: updatedDateAndTime.startMinutes.value 
            },
            currency_type: JSON.parse(Data.currency_type),
            on_sale_to: endDate,
            endHours: { 
              label: updatedDateAndTime.endHours.label, 
              value: updatedDateAndTime.endHours.value 
            },
            endMinutes: { 
              label: updatedDateAndTime.endMinutes.label, 
              value: updatedDateAndTime.endMinutes.value 
            },
          }
        });
      }
    } catch (error) {
      console.error("Error fetching ticket details:", error);
    }
  };

  useEffect(() => {
    if (ticket_id) {
      fetchTicketDetails(ticket_id);
    }
  }, [ticket_id]);

  return ticket && <Ticket data={ticket} ticket_id={ticket_id} edit={true} />;
};

export default EditTicket;
